export default [
  [
    "英文.com",
    "互联网公司优选的顶级域名",
    "150",
    "450",
    "750",
    "1500",
    "150",
    "150",
    "en"
  ],
  [
    "英文.cn",
    "企业互联网品牌标识",
    "120",
    "360",
    "600",
    "1200",
    "120",
    "120",
    "en"
  ],
  [
    "英文.net",
    "建立全球商业品牌的优质域名选择",
    "150",
    "450",
    "750",
    "1500",
    "150",
    "150",
    "en"
  ],
  [
    ".com.cn",
    "企业互联网品牌标识",
    "120",
    "360",
    "600",
    "1200",
    "120",
    "120",
    "en"
  ],
  [
    "中文.cn",
    "企业互联网品牌标识",
    "320",
    "960",
    "1600",
    "3200",
    "320",
    "320",
    "cn"
  ],
  [
    ".网络",
    "极具互联网标识的中文域名",
    "320",
    "960",
    "1600",
    "3200",
    "320",
    "320",
    "cn"
  ],
  // [
  //   '中文.cc',
  //   '蕴含商业意义的顶级域名',
  //   '80',
  //   '240',
  //   '400',
  //   '800',
  //   '80',
  //   '80'
  // ],
  [
    ".在线",
    "切合中文习惯的域名",
    "1980",
    "5940",
    "9900",
    "19800",
    "1980",
    "1980",
    "cn"
  ],
  [
    "中文.com",
    "互联网公司优选的顶级域名",
    "320",
    "960",
    "1600",
    "3200",
    "320",
    "320",
    "cn"
  ],
  [
    ".网址",
    "国内网址标识类域名",
    "2800",
    "8400",
    "14000",
    "28000",
    "2800",
    "2800",
    "cn"
  ],
  [
    ".企业",
    "即企业名称，塑造品牌价值",
    "1200",
    "3600",
    "6000",
    "12000",
    "1200",
    "1200",
    "cn"
  ],
  [
    ".中国",
    "塑造中国品牌的国家域名",
    "320",
    "960",
    "1600",
    "3200",
    "320",
    "320",
    "cn"
  ],
  [
    ".公司",
    "自带品牌宣传效果",
    "320",
    "960",
    "1600",
    "3200",
    "320",
    "320",
    "cn"
  ],
  // [
  //   ".手机",
  //   "移动互联网品牌推广利器",
  //   "2960",
  //   "8880",
  //   "14800",
  //   "29600",
  //   "2960",
  //   "2960",
  //   "cn"
  // ],
  [
    ".网店",
    "电商品牌优质选择",
    "1280",
    "3840",
    "6400",
    "12800",
    "1280",
    "1280",
    "cn"
  ],
  [
    ".中文网",
    "有效保护中文网址品牌",
    "1800",
    "5400",
    "9000",
    "18000",
    "1800",
    "1800",
    "cn"
  ],
  // [
  //   "中文.biz",
  //   "代表商业的新顶级域名",
  //   "240",
  //   "720",
  //   "1200",
  //   "2400",
  //   "240",
  //   "240",
  //   "cn"
  // ],
  [
    ".net.cn",
    "企业互联网品牌标识",
    "120",
    "360",
    "600",
    "1200",
    "120",
    "120",
    "en"
  ],
  [
    ".org.cn",
    "企业互联网品牌标识",
    "120",
    "360",
    "600",
    "1200",
    "120",
    "120",
    "en"
  ],
  [
    ".mobi",
    "企业移动推广的优质选择",
    "70",
    "330",
    "590",
    "1240",
    "130",
    "70",
    "en"
  ],
  // [
  //   "英文.biz",
  //   "代表商业的新顶级域名",
  //   "240",
  //   "720",
  //   "1200",
  //   "2400",
  //   "240",
  //   "240",
  //   "en"
  // ],
  // [".info", "网络时代的标识", "240", "720", "1200", "2400", "240", "240", "en"],
  [
    ".集团",
    "优质诠释企业实力",
    "12000",
    "36000",
    "60000",
    "120000",
    "12000",
    "12000",
    "cn"
  ],
  // [".club", "网聚人气的域名", "150", "450", "750", "1500", "150", "150", "en"],
  // [".xyz", "富有想象力域名", "150", "450", "750", "1500", "150", "150", "en"],
  // ["英文.company", "", "40", "120", "200", "400", "120", "120", "en"],
  // ["英文.world", "", "40", "120", "200", "400", "188", "188", "en"],
  // ["英文.store", "", "50", "150", "250", "500", "60", "60", "en"]
  // ['.fund', '富有想象力域名', '30', '40', '318', '1500', '150', '150', 'en'],
  // ['.gold', '富有想象力域名', '30', '40', '520', '1500', '150', '150', 'en'],
  // ['.group', '富有想象力域名', '30', '40', '120', '1500', '150', '150', 'en'],
  // ['.ltd', '富有想象力域名', '29', '118', '118', '1500', '150', '150', 'en'],
  // ['.tech', '富有想象力域名', '20', '78', '78', '1500', '150', '150', 'en'],
  // ['.top', '富有想象力域名', '10', '29', '29', '1500', '150', '150', 'en'],
  // ['.site', '富有想象力域名', '18', '80', '90', '1500', '150', '150', 'en'],
  // ['.link', '富有想象力域名', '76', '112', '112', '1500', '150', '150', 'en'],
  // ['.online', '富有想象力域名', '16', '49', '49', '1500', '150', '150', 'en'],
  // ['.ink', '富有想象力域名', '28', '249', '249', '1500', '150', '150', 'en'],
  // ['.vip', '富有想象力域名', '29.9', '37', '37', '1500', '150', '150', 'en'],
  // ['.shop', '富有想象力域名', '69', '249', '249', '1500', '150', '150', 'en'],
  // ['.work', '富有想象力域名', '29.9', '37', '37', '1500', '150', '150', 'en'],
  // [
  //   '.购物',
  //   '富有想象力域名',
  //   '12000',
  //   '12000',
  //   '12000',
  //   '1500',
  //   '150',
  //   '150',
  //   'en'
  // ],
  // ['.art', '富有想象力域名', '99', '126', '126', '1500', '150', '150', 'en'],
  // ['.wang', '富有想象力域名', '28', '48', '48', '1500', '150', '150', 'en'],
  // ['.wiki', '富有想象力域名', '38', '249', '249', '1500', '150', '150', 'en'],
  // ['.design', '富有想象力域名', '69', '599', '599', '1500', '150', '150', 'en'],
  // ['.co', '富有想象力域名', '299', '299', '299', '1500', '150', '150', 'en']
];



// WEBPACK FOOTER //
// ./static/assets/priceList.js